module.exports = __webpack_public_path__ + "static/media/Alex_Varianos.d9c03257.png";